import { useTheme } from '../hooks/useTheme';

/**
 * Alternância manual de tema (PRD seção 4) — some no cabeçalho da shell
 * autenticada. Ícone (sol/lua) em vez de rótulo de texto, a pedido do
 * usuário — igual ao padrão que ele já usa no RADIOPRO. `aria-label`
 * carrega o texto que o glifo sozinho não transmite pra leitor de tela.
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Modo claro' : 'Modo escuro';

  return (
    <button
      type="button"
      className={`theme-toggle ${isDark ? 'theme-toggle-sun' : 'theme-toggle-moon'}`}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? '☀️' : '🌙'}
    </button>
  );
}
